<template>
  <BaseDialog
    :visible="visible"
    :title="displayText.title"
    width="670px"
    :close-on-click-modal="false"
    @close="onClose"
    @confirm="onConfirm"
  >
    <BaseElForm ref="formBusinessRef" :model="localFormData" :rules="formRules" label-position="top">
      <BaseElFormItem prop="mode" :label="displayText.mode" class="mt-[20px]">
        <BaseElRadioGroup v-model="localFormData.mode">
          <BaseElRadio v-for="item in businessTimeOptions" :key="item.value" :label="$t(item.value)">{{ $t(item.label) }}</BaseElRadio>
        </BaseElRadioGroup>
      </BaseElFormItem>
      <div v-if="showControl.customWeek" class="special-time mb-[20px]">
        <hr class="mt-[20px] mb-[20px]">
        <p class="content">{{ $t('businessTimeSettings.description.title') }}</p>
        <ol>
          <li>{{ $t('businessTimeSettings.description.content1') }}</li>
          <li>{{ $t('businessTimeSettings.description.content2') }}</li>
        </ol>
        <AddTimes v-if="showControl.customWeekConfigs" :title="$t('businessTimeSettings.button.add.title')" :customWeekConfigs="localFormData.customWeekConfigs" isWeek timeStep="00:30" />
      </div>
      <BaseElFormItem prop="excludedDays" :label="displayText.excludedDays" class="mt-[20px]">
        <BaseElSwitch v-model="localFormData.excludedDays" :active-text="$t('common.open.text')" :inactive-text="$t('common.close.text')" />
      </BaseElFormItem>
      <BaseElFormItem v-if="showControl.shopExcludeTimeRules" :label="displayText.shopExcludeTimeRules" prop="shopExcludeTimeRules">
        <AddPeriodTimes :excludeTimeRule="localFormData.shopExcludeTimeRules" :omitList="['weekly']" />
      </BaseElFormItem>
    </BaseElForm>
  </BaseDialog>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import AddTimes from '@/components/AddTimes.vue'
import AddPeriodTimes from '@/components/AddPeriodTimes.vue'
import formUtils from '@/utils/form'
import { businessTimeOptions } from '@/config/date'
import { cloneDeep, get } from 'lodash'

export default defineComponent({
  name: 'ShopBusinessTimeDialog',
  components: { BaseDialog, AddTimes, AddPeriodTimes },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    formRules: {
      type: Object,
      required: true,
    },
  },
  emits: ['close', 'confirm'],
  setup (props, { emit }) {
    const formBusinessRef = ref(null)
    const localFormData = ref({})
    const displayText = computed(() => {
      const data = {
        title: '分店營業時間',
        mode: '營業模式',
        excludedDays: '排除特定營業時間',
        shopExcludeTimeRules: '排除特定時段',
      }
      return data
    })
    const showControl = computed(() => {
      const controls = {
        customWeek: get(localFormData.value, 'mode') === 'CustomWeek',
        customWeekConfigs: get(localFormData.value, 'customWeekConfigs'),
        shopExcludeTimeRules: get(localFormData.value, 'excludedDays'),
      }
      return controls
    })
    const onClose = () => {
      emit('close')
    }

    const onConfirm = async () => {
      const valid = await formUtils.checkForm(formBusinessRef.value)
      if (valid) {
        emit('confirm', localFormData.value)
      }
    }

    onMounted(() => {
      localFormData.value = cloneDeep(props.formData)
    })

    return {
      formBusinessRef,
      localFormData,
      onClose,
      onConfirm,
      displayText,
      showControl,
      businessTimeOptions,
    }
  },
})
</script>

<style scoped>
</style>
